export { default as ClaimTab } from "./AllClaimsTab";
export type { ClaimTabKey } from "./AllClaimsTab";
export { default as ClaimHistoryTab } from "./ClaimHistoryTab";
